exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".copritutto{z-index:99999999;width:100%;height:100%;position:absolute;top:0px;left:0px;background-color:#262626;background-image:url(" + require("../assets/loading.gif") + ");background-repeat:no-repeat;background-attachment:fixed;background-position:center}.bsscaricamentowrapper{z-index:99999999;width:100%;height:100%;background:#000 !important;color:#fff;font-size:bolder;position:absolute;top:0px;left:0px}", ""]);

// exports
